import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { faChevronRight, faFileLines, faTimes, faWarehouse } from '@fortawesome/free-solid-svg-icons';

@Component({
  selector: 'bulk-move-selection-popup',
  templateUrl: './bulk-move-selection-popup.component.html',
  styleUrls: ['./bulk-move-selection-popup.component.scss']
})
export class BulkMoveSelectionPopupComponent {
  public faChevronRight = faChevronRight;
  public faFileLines = faFileLines;
  public faTimes = faTimes;
  public faWarehouse = faWarehouse;

  constructor(
    public dialogRef: MatDialogRef<BulkMoveSelectionPopupComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private router: Router
  ) {}

  navigateToLocation() {
    this.dialogRef.close();
    this.router.navigateByUrl("/harvest-engine/inventory/inventory-bulk-move");
  }

  navigateToOrder() {
    this.dialogRef.close();
    this.router.navigateByUrl("/harvest-engine/inventory/inventory-bulk-move-to-order");
  }

  cancel() {
    this.dialogRef.close();
  }
}
